import { Outlet } from "react-router-dom";
import ModuleSubNav from "../../layouts/ModuleSubNav";

const AssignmentLayout = () => {
 const tabs = [
  { name: "Dashboard", path: "/assignments", end: true },
  { name: "Create Engagement", path: "/assignments/create" },
  { name: "Engagement Register", path: "/assignments/register" }
];


  return (
    <>
      <ModuleSubNav tabs={tabs} />
      <Outlet />
    </>
  );
};

export default AssignmentLayout;
